module.exports = __webpack_public_path__ + "static/media/arrow-down.9d58dd50.svg";